export default __webpack_public_path__ + "static/media/LifeScience.c1c493a6.png";